import React, { useState, useEffect } from "react";
import { ClipLoader } from "react-spinners"; // Import spinner
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import HeaderCard from "components/headers/HomeHeader";
import FeatureCard from "components/home-cards/FeatureCard";
import DestinationCard from "components/home-cards/DestinationCard";
import TourCard from "components/home-cards/TourCard";
import HotelCard from "components/home-cards/HotelCard";
import GalleryCard from "components/home-cards/GalleryCard";
import BlogCard from "components/home-cards/BlogCard";
import ReviewCard from "components/home-cards/ReviewCard";
import EnquiryCard from "components/home-cards/EnquiryCard";
import FooterCard from "components/footers/PageFooter";
import AboutCard from "components/home-cards/AboutCard";
import OfferCard from "components/home-cards/OfferCard";

export default function LandingPage() {
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   // Simulate API calls delay
  //   const fetchData = async () => {
  //     await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulated delay
  //     setLoading(false);
  //   };
    
  //   fetchData();
  // }, []);

  return (
    <AnimationRevealPage>
      {loading ? (
        <div style={styles.loaderContainer}>
          <ClipLoader size={60} color="#ff6600" />
          <p>Loading...</p>
        </div>
      ) : (
        <>
          <HeaderCard />
          <AboutCard />
          <OfferCard />
          <FeatureCard />
          <DestinationCard />
          <TourCard />
          <HotelCard />
          <GalleryCard />
          <BlogCard />
          <ReviewCard />
          <EnquiryCard />
          <FooterCard />
        </>
      )}
    </AnimationRevealPage>
  );
}

// Loader styles
const styles = {
  loaderContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#fff",
  },
};
